__turbopack_context__.v({
  "bookIcon": "Sidebar-module-scss-module__ydT3aG__bookIcon",
  "calendarIcon": "Sidebar-module-scss-module__ydT3aG__calendarIcon",
  "gridIcon": "Sidebar-module-scss-module__ydT3aG__gridIcon",
  "loginIcon": "Sidebar-module-scss-module__ydT3aG__loginIcon",
  "logoutIcon": "Sidebar-module-scss-module__ydT3aG__logoutIcon",
  "sidebar": "Sidebar-module-scss-module__ydT3aG__sidebar",
  "studentIcon": "Sidebar-module-scss-module__ydT3aG__studentIcon",
  "sunIcon": "Sidebar-module-scss-module__ydT3aG__sunIcon",
  "trendingUpIcon": "Sidebar-module-scss-module__ydT3aG__trendingUpIcon",
  "userIcon": "Sidebar-module-scss-module__ydT3aG__userIcon",
  "worldIcon": "Sidebar-module-scss-module__ydT3aG__worldIcon",
});
